import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { TweenMax } from "gsap";
import { isEqual } from "lodash";
import styles from "./radio.module.scss";
import globalStyles from "../common.module.scss";

export default class Radio extends Component {
  constructor(props) {
    const defaultOptIndex = props.defaultOptIndex;
    super(props);
    this.state = {
      selected: defaultOptIndex,
      valid: true,
    };
  }

  componentDidMount() {
    const defaultOptIndex = this.props.defaultOptIndex;
    // Set default value in parent state
    if (Number(defaultOptIndex) > -1) {
      this.props.onChange &&
        this.props.onChange(
          null,
          this.props.id,
          this.props.options[defaultOptIndex]
        );
    }
  }

  handleChange = (e) => {
    this.setState({
      selected: this.props.options.findIndex((i) => i === e.target.value),
    });
    this.props.onChange &&
      this.props.onChange(e, this.props.id, e.target.value);
  };

  render() {
    const { id, label, isRequired, disabled, options } = this.props;
    const { selected } = this.state;
    return (
      <Fragment>
        <div
          className={`${styles.Radio} ${disabled ? globalStyles.disabled : ""}`}
          ref={(el) => (this.container = el)}
        >
          <p>{label + (!isRequired ? " (optional)" : "")}</p>
          {options.map((opt, index) => (
            <div className={styles.RadioOpt}>
              <input
                type="radio"
                checked={selected === index}
                id={opt}
                name={id}
                value={opt}
                onChange={this.handleChange}
              />
              <label htmlFor={opt}>{opt}</label>
              <br />
            </div>
          ))}
        </div>
      </Fragment>
    );
  }
}

Radio.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
};

Radio.defaultProps = {
  isRequired: false,
  options: [],
};
